export default "__VITE_ASSET__CdvTyxmF__"